var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SearchPanel',{attrs:{"dashId":_vm.dashId,"published":_vm.published,"entry":_vm.entry}}),_c('div',{staticClass:"mt-1"}),_c('Dashboard',{attrs:{"user":_vm.user,"dashId":_vm.dashId,"published":_vm.published}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }